import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedIn: boolean = false;

  constructor() { }

  isLoggedIn(){
    

    if(localStorage.getItem('token') && localStorage.getItem('user')){
      this.loggedIn = true;
    }else{
      this.loggedIn = false;
    }

    return this.loggedIn;

  }

}
